import { Avatar, Box, Stack, Typography } from '@mui/material'
import Modal from '../../../molecules/Modal'

const supportedLanguages = [
    {
        name: "English (USA)",
        code: "us"
    },
    {
        name: "French (France)",
        code: "fr"
    },
]

export default function InternationalizationModal({visible, setVisibility}) {
    return (
        <Modal
            title="Internationalization"
            subtitle="Please choose your desired language"
            visible={visible}
            setVisibility={setVisibility}
        >
            <Box
                sx={{
                    maxWidth: "70%",
                    height: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "1rem"
                }}
            >
                {
                    supportedLanguages.map((language, index)=>(
                        <Stack
                            direction="column"
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "1rem",
                                width: "fit-content",
                            }}
                            spacing={1}
                            key={index}
                        >
                            <Avatar
                                src={`https://flagcdn.com/w160/${language.code}.png`}
                            />
                            <Typography variant="subtitle2" color="grey.500" fontSize="14px">
                                {language.name}
                            </Typography>
                        </Stack>
                    ))
                }

            </Box>
            
        </Modal>
    )
}
